import React from 'react';
import { C } from '../../theme.js';
import { Eyebrow } from '../../components/Primitives.jsx';
import { SOURCE_COLUMNS } from '../../data.js';
import { ColumnsContext } from '../StepInspector.jsx';
import { MultiCols } from '../shared/MultiCols.jsx';

// ── Profile inspectors (live stats, no row change) ─────────────────────
export function ProfileColumnsInspector({ step, onChange, columns }) {
  const ctxCols = React.useContext(ColumnsContext);
  const cols = columns || ctxCols || SOURCE_COLUMNS;
  const c = step.config || {};
  const sel = c.columns || cols.map(co => co.name);
  return (
    <div>
      <Eyebrow>Profile columns</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        Computes min · max · mean · median · null count · cardinality for the
        selected columns. Profile output streams into the run log; rows pass
        through unchanged.
      </div>
      <MultiCols selected={sel} onChange={(v) => onChange({ ...step, config: { ...c, columns: v } })} />
    </div>
  );
}
